import React, { useCallback } from 'react';
import {MenuItem,} from "~/native-ui/Menu";
import styled from "styled-components/native";
import { WithBaseStyles } from "../hoc";

const MenuItemWrapped = React.memo(({ children, ...props}) => {
    const hoverRef = React.useRef(null);
    const isUmountedRef = React.useRef(false);
    const [isHovered, setHovered] =  React.useState(false);

    
    const hoverInHandler = useCallback(() => {
        if (isUmountedRef.current) return;
        setHovered(true);
    }, [])

    
    const hoverOutHandler = useCallback(() => {
        if (isUmountedRef.current) return;
        setHovered(false);
    }, [])



    const addEventListeners = useCallback(() => {
        if (!hoverRef.current) return;
        hoverRef.current.addEventListener("mouseenter", hoverInHandler);
        hoverRef.current.addEventListener("mouseleave", hoverOutHandler);
    }, [hoverInHandler, hoverOutHandler])

    
    const removeEventListeners = useCallback(() => {
        hoverRef.current.removeEventListener("mouseenter", hoverInHandler);
        hoverRef.current.removeEventListener("mouseleave", hoverOutHandler);
    }, [hoverInHandler, hoverOutHandler])

    
    
    const setHoverRef = useCallback((node) => {
        if (!node) removeEventListeners();
        hoverRef.current = node;
        addEventListeners();
    }, []);
    

    React.useEffect(() => () => {
        isUmountedRef.current = true;
    }, []);

    if (typeof children === 'function') children = children({ isHovered });

    return (
        <div ref={setHoverRef}>
            <MenuItem { ...props }>
                { children }
            </MenuItem>
        </div>
    )
})

export const DropdownOption = styled(WithBaseStyles(MenuItemWrapped, {
    baseStyle: {
        borderTopWidth: 1,
        borderTopColor: "gray.300",
        py: 2,
    }
}))`
    cursor: pointer;
`